module.exports = __webpack_public_path__ + "df3bfbd121df74649119e31980fdc957.svg";